import React, { Fragment, useEffect, useState } from "react";
import { ResponsiveHeader } from "pages/_components/header";
import { useSelector, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { useParams } from "react-router-dom";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import { actions as debinActions } from "reducers/debin";
import { actions as accountsActions } from "reducers/accounts";
import { actions as notificationActions } from "reducers/notification";
import Loader from "pages/_components/Loader";
import Notification from "pages/_components/Notification";
import { statusTagColor } from "util/debin";
import * as i18n from "util/i18n";
import { Col, Row } from "react-bootstrap";
import { bool } from "prop-types";
import CustomData from "pages/_components/CustomData/CustomData";
import parse from "date-fns/parse";
import addDays from "date-fns/add_days";
import isAfter from "date-fns/is_after";
import isBefore from "date-fns/is_before";
import DataReceivedDebin from "./_components/DataReceivedDebin";
import InfoTag from "../_components/InfoTag";

const regexCuota = new RegExp(/^\d{3}\/\d{3}$/);

const DetailReceivedDebin = ({ isDesktop }) => {
    const { fetching, sentRequests, debinDetail } = useSelector((state) => state.debin);
    const { fetching: fetchingAccounts, accounts } = useSelector((state) => state.accounts);
    const { id } = useParams();
    const dispatch = useDispatch();
    const receivedDebin = sentRequests?.debinList?.find((object) => object.id === id);
    const account = accounts?.find((object) => object?.cbu?.substring(9) === receivedDebin?.buyer?.cbu);
    const bankBranch = `${debinDetail?.sellerDetail?.bank ?? "-"} / ${debinDetail?.sellerDetail?.branch ?? "-"}`;
    const [hideButton, setHideButton] = useState(false);
    const [titleId, setTitleId] = useState("");
    const [isScheduledDebin, setIsScheduledDebin] = useState(false);
    const [fee, setFee] = useState(null);
    const isScheduled = debinDetail?.description && regexCuota.test(debinDetail?.description);
    const isTRXPL = receivedDebin?.type === "TRXPL";

    useEffect(() => {
        const isDetail = true;
        dispatch(debinActions.acceptIncomingRequestPre(id, isDetail));
    }, [sentRequests]);

    useEffect(() => {
        dispatch(accountsActions.listAccountsCbu());
    }, []);

    const resolveTitleId = () => {
        if (isScheduled) {
            return "debin.received.detail";
        }
        if (isTRXPL) {
            return "pull.transfer.detail.title";
        }
        return "debin.received.detail.title";
    };

    useEffect(() => {
        if (!debinDetail?.idTransaction) {
            if (account?.availableBalance && debinDetail?.amount?.quantity) {
                if (account?.availableBalance < debinDetail?.amount?.quantity) {
                    dispatch(
                        notificationActions.showNotification(i18n.get("debin.insuficient.funds"), "error", [
                            "debinPaymentsDetailPay",
                        ]),
                    );
                    setHideButton(true);
                } else {
                    setHideButton(false);
                }
            } else {
                setHideButton(true);
            }

            setIsScheduledDebin(isScheduled);
            setTitleId(resolveTitleId());

            if (isScheduled) {
                setFee(debinDetail?.description.split("/")[0]);
            }
        } else {
            setHideButton(false);
        }
    }, [account, debinDetail]);

    if (fetching || fetchingAccounts) {
        return <Loader />;
    }

    const State = () => (
        <InfoTag
            type="info"
            message={receivedDebin?.status?.code}
            tagBackground={statusTagColor(receivedDebin?.status?.code)}
        />
    );
    const debitAccountMask = `****${account?.shortLabel?.substring(1)}`;
    const dispatchItems = () => {
        dispatch(debinActions.acceptIncomingRequestPre(receivedDebin.id));
        dispatch(accountsActions.listAccountsCbu());
    };
    const validatePayWeb = () => {
        if (account?.availableBalance > debinDetail?.amount?.quantity) {
            dispatchItems();
            dispatch(push("/debinPayments/action/received"));
        } else {
            dispatch(
                notificationActions.showNotification(i18n.get("debin.pay.summary.detail.error"), "error", [
                    "debinPaymentsDetailPay",
                ]),
            );
        }
    };

    const handleChargeBack = () => {
        const debinToChargeBack = {
            sellerName: debinDetail?.sellerDetail?.titular,
            debitAccountMask,
            quantity: debinDetail?.amount?.quantity,
            currency: debinDetail?.amount?.currency,
            issuedDate: debinDetail?.creationDate,
            expirationDate: debinDetail?.expirationDate,
            debinId: debinDetail?.id,
            sellerDocumentNumber: debinDetail?.sellerDetail?.documentNumber,
            sellerCbu: debinDetail?.sellerDetail?.cbu,
            sellerAlias: debinDetail?.sellerDetail?.cbuAlias || "-",
            sellerBank: debinDetail?.sellerDetail?.bank || "-",
            sellerBranch: debinDetail?.sellerDetail?.branch || "-",
            concept: debinDetail?.concept,
            quote: debinDetail?.description,
            reference: debinDetail?.reference || "-",
            buyerDocumentNumber: debinDetail?.buyerDetail.documentNumber,
            buyerCBU: debinDetail?.buyerDetail.cbu,
            isTRXPL,
        };
        dispatch(debinActions.setDebinToChargeBack(debinToChargeBack));
        dispatch(push(`/debin/chargeBack`));
    };

    const isBeforeXDays = (startDateValue, days) => {
        if (!startDateValue) {
            return false;
        }

        const startDate = parse(startDateValue);
        const limitDate = addDays(startDate, days);
        const today = new Date();

        return isAfter(today, startDate) && isBefore(today, limitDate);
    };

    const buttons = () => (
        <>
            {receivedDebin?.status?.code === "INICIADO" && (
                <>
                    <Row className="pb-9">
                        <Col xs={12} md={4} mdOffset={2}>
                            <Button
                                className="btn btn-outline btn-default btn-block flex"
                                label="debin.reject.debin"
                                onClick={() => {
                                    dispatchItems();
                                    dispatch(push("/debinPayments/action/reject"));
                                }}
                            />
                        </Col>
                        <Col xs={12} md={4} mdOffset={6} className="grid-row-end">
                            <Button
                                className="btn btn-primary btn-default btn-block flex"
                                label="debin.pay.debin"
                                onClick={() => {
                                    validatePayWeb();
                                }}
                                disabled={hideButton}
                            />
                        </Col>
                    </Row>
                </>
            )}
            {isScheduledDebin &&
                debinDetail?.status?.code === "ACREDITADO" &&
                fee &&
                fee === "001" &&
                isBeforeXDays(debinDetail?.creationDate, 30) && (
                    <>
                        <Row className="pb-9">
                            <Col xs={12} md={4} mdOffset={4} className="grid-row-end">
                                <Button
                                    className="btn btn-primary btn-default btn-block flex"
                                    label="debin.request.chargeback"
                                    defaultLabelText="Solicitar Contracargo"
                                    onClick={() => {
                                        handleChargeBack();
                                    }}
                                />
                            </Col>
                        </Row>
                    </>
                )}

            {isTRXPL && debinDetail?.status?.code === "ACREDITADO" && isBeforeXDays(debinDetail?.creationDate, 60) && (
                <>
                    <Row className="pb-9">
                        <Col xs={12} md={4} mdOffset={4} className="grid-row-end">
                            <Button
                                className="btn btn-primary btn-default btn-block flex"
                                label="debin.request.chargeback"
                                defaultLabelText="Solicitar Contracargo"
                                onClick={() => {
                                    handleChargeBack();
                                }}
                            />
                        </Col>
                    </Row>
                </>
            )}
        </>
    );

    return (
        <Fragment>
            <Notification scopeToShow="debinPaymentsDetailPay" />
            <ResponsiveHeader
                id={titleId}
                defaultTitle="Detalle de DEBIN"
                backLinkTo="/debinPayments"
                infoComponents={
                    isDesktop && (
                        <div className="pl-4">
                            <State />
                        </div>
                    )
                }
            />
            <MainContainer showLoader={fetching || fetchingAccounts}>
                <DataReceivedDebin
                    debitAccount={debitAccountMask || "-"}
                    availableBalance={account?.availableBalance || "-"}
                    curencyBuyer={account?.currency || "-"}
                    sellerName={debinDetail?.sellerDetail?.titular || "-"}
                    sellerCuit={
                        `${debinDetail?.sellerDetail?.documentType} ${debinDetail?.sellerDetail?.documentNumber}` || "-"
                    }
                    curencySeller={debinDetail?.amount?.currency || "-"}
                    amount={debinDetail?.amount?.quantity || "-"}
                    solicitDate={debinDetail?.creationDate || "-"}
                    dueDate={debinDetail?.expirationDate || "-"}
                    debinId={debinDetail?.id || "-"}
                    sellerCbu={debinDetail?.sellerDetail?.cbu || "-"}
                    alias={debinDetail?.sellerDetail?.cbuAlias || "-"}
                    bank={bankBranch || "-"}
                    concept={debinDetail?.concept || "-"}
                    description={debinDetail?.description || "-"}
                    reference={debinDetail?.reference || "-"}
                    isDesktop={isDesktop}
                    isTRXPL={isTRXPL}
                />
                {(debinDetail?.status?.code === "ERROR DEBITO" || debinDetail?.status?.code === "ERROR DATOS") &&
                    debinDetail?.status?.description && (
                        <div className="container--alert" role="alert">
                            <div className="alert alert-info">
                                <CustomData
                                    icon="information_fill.svg"
                                    titleText={
                                        debinDetail?.status?.description.charAt(0).toUpperCase() +
                                        debinDetail?.status?.description.slice(1).toLowerCase()
                                    }
                                    keepSpaceIfNoValue={false}
                                />
                            </div>
                        </div>
                    )}
                {buttons()}
            </MainContainer>
        </Fragment>
    );
};

DetailReceivedDebin.propTypes = {
    isDesktop: bool.isRequired,
};

export default DetailReceivedDebin;
